const declarationTemplate = `
<div id="container" style="font-family:Roboto,Arial,sans-serif;font-size:14px;line-height:1.7;color:#000;padding:20px 38px;max-width:760px;margin:auto;">
  <table width="100%" style="border-collapse:collapse;margin-bottom:34px;">
    <tbody>
      <tr>
        <td style="border:1px solid #d2d2d2;width:210px;padding:10px;text-align:center;">
          <img id="logo" src="https://maxicus.com/mailer/maxicus.png" alt="logo" style="width:170px;height:60px;object-fit:contain;" />
        </td>
        <td style="border:1px solid #d2d2d2;text-align:center;padding:10px;">
          <h1 id="company_name" style="font-size:24px;font-weight:bold;margin:0;">Maxicus Technologies Pvt. Ltd.</h1>
        </td>
      </tr>
      <tr>
        <td style="border:1px solid #d2d2d2;"></td>
        <td style="border:1px solid #d2d2d2;text-align:center;padding:12px;">
          <h2 style="font-size:20px;font-weight:700;margin:0;">DECLARATION - CUM - UNDERTAKING</h2>
        </td>
      </tr>
    </tbody>
  </table>

  <p style="margin-bottom:28px;">
    I, <span id="name" style="display:inline-block;min-width:210px;border-bottom:1px solid #000;"></span>, hereby declare as follows:
  </p>

  <ol style="padding-left:42px;margin:0;">
    <li style="margin-bottom:18px;text-align:justify;">
      I acknowledge that the terms and conditions of my Offer Letter and all related employment documents are strictly confidential. I undertake that I shall not disclose, reproduce, or share the contents of these documents with any third party, including but not limited to social media platforms, without the prior written consent of the Company. I understand that this obligation shall survive the termination of my employment.
    </li>
    <li style="margin-bottom:34px;text-align:justify;">
      I confirm that I have accepted this offer of employment in reference to the application made for this position and hereby represent and warrant that I have not engaged in any conduct that is improper or contrary to ethical standards. I further declare that I have not provided any special favors or advantages to any individual, directly or indirectly, to facilitate or obtain this employment opportunity.
    </li>
  </ol>

  <table style="margin-top:34px;border-collapse:collapse;width:520px;">
    <tbody>
      <tr>
        <td style="font-weight:bold;padding:8px 10px 8px 0;width:160px;white-space:nowrap;vertical-align:bottom;">Name</td>
        <td style="font-weight:bold;padding:8px 8px 8px 0;width:14px;text-align:center;vertical-align:bottom;">:</td>
        <td style="padding:8px 0;vertical-align:bottom;">
          <span id="name_1" style="display:inline-block;width:260px;border-bottom:1px solid #000;min-height:20px;"></span>
        </td>
      </tr>
      <tr>
        <td style="font-weight:bold;padding:8px 10px 8px 0;width:160px;white-space:nowrap;vertical-align:bottom;">Date</td>
        <td style="font-weight:bold;padding:8px 8px 8px 0;width:14px;text-align:center;vertical-align:bottom;">:</td>
        <td style="padding:8px 0;vertical-align:bottom;">
          <span id="date_of_joining" style="display:inline-block;width:260px;border-bottom:1px solid #000;min-height:20px;"></span>
        </td>
      </tr>
      <tr>
        <td style="font-weight:bold;padding:8px 10px 8px 0;width:160px;white-space:nowrap;vertical-align:middle;">Signature</td>
        <td style="font-weight:bold;padding:8px 8px 8px 0;width:14px;text-align:center;vertical-align:middle;">:</td>
        <td style="padding:8px 0;vertical-align:middle;">
          <span style="display:inline-block;width:260px;height:68px;border:1px solid #000;vertical-align:middle;box-sizing:border-box;padding:4px 10px;">
            <img id="signature" src="" alt="" style="display:block;width:100%;height:100%;object-fit:contain;object-position:center;border:0;margin:0;" />
          </span>
        </td>
      </tr>
    </tbody>
  </table>
</div>
`;

export const declarationData = {
  all: {
    text: declarationTemplate,
  },
  maxicus: {
    text: declarationTemplate,
  },
  kochar: {
    text: declarationTemplate,
  },
  igzy: {
    text: declarationTemplate,
  },
  kochiva: {
    text: declarationTemplate,
  },
  kocharsoft: {
    text: declarationTemplate,
  },
};
